  <template>
    <b-row>
      <b-col cols="12">
        <b-btn variant="danger" @click.stop="backToMemberList()">Return to Member List</b-btn>
        <hr>
        <b-jumbotron>
          <b-form @submit="onSubmit">
            <b-form-group id="fieldsetHorizontal"
                      horizontal
                      :label-cols="4"
                      breakpoint="md"
                      label="First Name:">
              <b-form-input required id="first_name" v-model.trim="member.first_name"></b-form-input>
            </b-form-group>

            <b-form-group id="fieldsetHorizontal"
                      horizontal
                      :label-cols="4"
                      breakpoint="md"
                      label="Last Name:">
                <b-form-input required id="last_name" v-model.trim="member.last_name"></b-form-input>
            </b-form-group>

            <b-form-group id="fieldsetHorizontal"
                      horizontal
                      :label-cols="4"
                      breakpoint="md"
                      label="Address Line 1:">
              <b-form-input required id="address_1" v-model.trim="member.address_1"></b-form-input>
            </b-form-group>

            <b-form-group id="fieldsetHorizontal"
                      horizontal
                      :label-cols="4"
                      breakpoint="md"
                      label="Address Line 2:">
              <b-form-input id="address_2" v-model.trim="member.address_2"></b-form-input>
            </b-form-group>

            <b-form-group id="fieldsetHorizontal"
                      horizontal
                      :label-cols="4"
                      breakpoint="md"
                      label="City:">
              <b-form-input required id="city" v-model.trim="member.city"></b-form-input>
            </b-form-group>

            <b-form-group id="fieldsetHorizontal"
                      horizontal
                      :label-cols="4"
                      breakpoint="md"
                      label="Post Code:">
              <b-form-input required id="postcode" v-model.trim="member.postcode"></b-form-input>
            </b-form-group>

            <b-form-group id="fieldsetHorizontal"
                      horizontal
                      :label-cols="4"
                      breakpoint="md"
                      label="Contact No.:">
              <b-form-input required id="mobile_no" v-model.trim="member.mobile_no"></b-form-input>
            </b-form-group>

          <b-form-group id="fieldsetHorizontal"
                      horizontal
                      :label-cols="4"
                      breakpoint="md"
                      label="Membership Level">
              <b-form-select required id="membership" v-model.trim="member.membership">
                <option value="Standard">Standard</option>
                <option value="Student">Student</option>
              </b-form-select>
          </b-form-group>

          <b-form-group id="fieldsetHorizontal"
                      horizontal
                      :label-cols="4"
                      breakpoint="md"
                      label="On Probation?">
              <b-form-select required id="probation" v-model.trim="member.probation">
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </b-form-select>
              </b-form-group>

              <b-form-group id="fieldsetHorizontal"
                      horizontal
                      :label-cols="4"
                      breakpoint="md"
                      label="Member Since:">
              <b-form-input required type="date" id="member_since" v-model.trim="member.member_since"></b-form-input>
            </b-form-group>

            <b-button type="submit" variant="primary">Save</b-button>
          </b-form>
        </b-jumbotron>
      </b-col>
    </b-row>
  </template>

  <script>

  import firebase from '../Firebase'
  import router from '../router/index.js'

  export default {
    name: 'AddMember',
    data () {
      return {
        ref: firebase.firestore().collection('members'),
        member: {},
        scrolled: false
      }
    },
    methods: {
      onSubmit (evt) {
        evt.preventDefault()

        this.ref.add(this.member).then((docRef) => {
          this.member.first_name = ''
          this.member.last_name = ''
          this.member.address = ''
          this.member.postcode = ''
          this.member.mobile_no = ''
          this.member.membership = ''
          this.member.probation = ''
          router.push({
            name: 'MemberList'
          })
        })
        .catch((error) => {
          alert("Error adding document: ", error);
        });
      },

      backToMemberList() {
        router.push({ name: 'MemberList'})
      }
    }
  }
  </script>

  <style>
    .jumbotron {
      padding: 2rem;
    }
  </style>